const fetch = require('cross-fetch');

function getExchangeRates(currencies) {
  return fetch(
    `https://api.exchangeratesapi.io/latest?symbols=${(
      currencies || ['USD']
    ).join(',')}`,
  )
    .then((response) => {
      if (response.status === 200) {
        return response.json();
      }

      throw new Error();
    })
    .then((json) => json.rates);
}

module.exports = {
  getExchangeRates,
};
